<template>
  <v-flex xs12 row>
    <v-layout py-3>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            
            <autocomplete
              v-model="filter.period"
              label="Time Period"
              search-key="type"
              :items="$options.periods"
            />
            
            <date-picker 
              v-if="filter.period === 'monthly'" 
              v-model="filter.year_month" 
              :min="minDateFrom" 
              :max="maxDate" 
              label="Year & Month" 
              class="mr-3" 
              type="month" 
            />

            <date-picker 
              v-else 
              v-model="filter.date_from" 
              :min="minDateFrom" 
              :max="maxDate" 
              :label="dateFromLabel" 
              class="mr-3" 
            />

            <date-picker 
              v-if="hasDateTo" 
              v-model="filter.date_to" 
              :disabled="!isDateToEditable"
              :min="minDateTo" 
              :max="maxDateTo" 
              label="Date To" 
              class="mr-3"
            />

            <autocomplete
              async
              clearable
              v-model="filter.retailer"
              label="Branch"
              sub-title="phone"
              key="retailer"
              :api-path="config.apis.searchRetailers"
            />

            <autocomplete
              async
              clearable
              v-model="filter.executive"
              label="Care of"
              sub-title="mobile"
              search-key="first_name"
              key="executive"
              :api-path="config.apis.searchExecutives"
            />

            <autocomplete
              async
              clearable
              v-model="filter.agent"
              label="LTP"
              sub-title="title"
              search-key="id"
              key="agent"
              :api-path="config.apis.searchAgents"
            />

            <autocomplete 
              async
              clearable
              v-model="filter.customer"
              label="Customer Mobile"
              sub-title="title"
              search-key="mobile"
              key="customer-mobile"
              :api-path="config.apis.searchCustomers"
            />

            <autocomplete
              async
              clearable
              v-model="filter.customer"
              label="Customer Name"
              sub-title="mobile"
              key="customer-name"
              :api-path="config.apis.searchCustomers"
            />

            <search-btn @click="loadReport" />

            <v-spacer></v-spacer>

          </v-card-title>
          
          <data-table
            :headers="headers"
            :items="processedItems"
            :loading="processing"
            :title="resultTitle"
            :sheet-name="sheetName"
            hide-actions
            download
          ></data-table>

      </v-card>
      </v-flex>
    </v-layout>
    
  </v-flex>
</template>

<script>

  import { reports } from '../../config/apis'

  import reportMixin from '../../mixins/reports'

  import DataTable from '../../components/DataTable'
  import DatePickerDialog from '../../components/DatePickerDialog'

  export default {
    
    components: {
      'data-table': DataTable,
      'date-picker': DatePickerDialog,
    },

    mixins: [ 
      reportMixin,
    ],

    data () {
      return {
        title: "Commission Report",
        reportsApiPath: reports.commission,
        filter: {
          period: "daily",
          date_from: this.today('YYYY-MM-DD'),
          date_to: '',
          year_month: '',
          customer: null,
          retailer: null,
          agent: null,
        },
        hasDateWiseReport: false,
      }
    },

    computed: {
    	
      processedItems() {
          
        return this.items.map(item => {
          return {
            code: item.code,
            order_date: item.order_date,
            customer_name: item.customer_name,
            total: item.total,
            retailer_name: item.retailer_name,
            retailer_commission: item.retailer_commission,
            agent_name: item.agent_name,
            agent_commission: item.agent_commission,
            executive_name: item.executive_name,
            executive_commission: item.executive_commission,
          }
        })
        
      },

    },

    watch: {

      'filter.retailer' (val) {

        if (!val) {
          this.filter.retailer = ""
        }
      },

    },

    created () {

      this.$options.itemWiseHeaders = [
        { text: 'Order ID', value: 'code', sortable: false},
        { text: 'Order Date', value: 'order_date', sortable: false},
        { text: 'Customer', value: 'customer_name', sortable: false},
        { text: `Total (${this.currency})`, value: 'total', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: 'Branch', value: 'retailer_name', sortable: false},
        { text: 'Branch Commission', value: 'retailer_commission', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: 'LTP', value: 'agent_name', sortable: false, default: '-'},
        { text: 'LTP Commission', value: 'agent_commission', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: 'Care of', value: 'executive_name', sortable: false, default: '-'},
        { text: 'Care of Commission', value: 'executive_commission', sortable: false, customFilter: 'roundValue', align: 'right'},
      ]

    },

  }
</script>
